/* eslint-disable react-hooks/exhaustive-deps */
import { Descriptions, Spin, Typography } from 'antd';
import moment from 'moment';
import React, { useEffect } from 'react';
import { useSiniestroContext } from '../../../../context/siniestro-context';

const { Title, Paragraph } = Typography;
const descriptionProps = {
  style: { paddingTop: 24 },
  column: 1,
  size: 'small',
  bordered: true,
  labelStyle: { width: 100 }
};
const LandingPage = (props) => {
  const { datosSiniestro, loading } = useSiniestroContext();

  useEffect(() => {
    props.setStart(true);
  }, []);

  return (
    <div style={{ textAlign: 'left' }}>
      <Spin spinning={loading} delay={500} size="large" tip="Cargando...">
        <div className="content" />
      </Spin>
      {!loading && (
        <>
          <Descriptions
            title=""
            style={{ textAlign: 'left', marginTop: 30, display: 'block' }}
          >
            <Descriptions.Item label="">
              <span style={{ fontWeight: 'bold', flexGrow: 0.5 }}>Sr/Sra.</span>
              {datosSiniestro?.poliza.solicitud?.cotizacion?.persona.nombres ||
                ''}
            </Descriptions.Item>
          </Descriptions>{' '}
          <Descriptions title="" style={{ textAlign: 'left' }}>
            <Descriptions.Item label="">
              Favor seguir las instrucciones para continuar con el proceso de
              inspección por la denuncia de siniestro correspondiente a su
              Seguro de {datosSiniestro.poliza.producto.descripcion}:
            </Descriptions.Item>
          </Descriptions>
          {(datosSiniestro.poliza.id_producto === 1 ||
            datosSiniestro.poliza.id_producto === 7) && (
            <>
              <Descriptions title="Vehículo" {...descriptionProps}>
                <Descriptions.Item label="Marca">
                  {datosSiniestro?.poliza?.vehiculo.marca.descripcion || ''}
                </Descriptions.Item>
                <Descriptions.Item label="Modelo">
                  {datosSiniestro?.poliza?.vehiculo.modelo.descripcion || ''}
                </Descriptions.Item>
                <Descriptions.Item label="Sub-modelo">
                  {datosSiniestro?.poliza?.vehiculo.submodelo.descripcion || ''}
                </Descriptions.Item>
                <Descriptions.Item label="Año">
                  {datosSiniestro?.poliza?.vehiculo.aniosubmodelo.descripcion ||
                    ''}
                </Descriptions.Item>
                <Descriptions.Item label="Chapa">
                  {datosSiniestro?.poliza?.vehiculo.chapa || ''}
                </Descriptions.Item>
                <Descriptions.Item label="Chassis">
                  {datosSiniestro?.poliza?.vehiculo.chassis || ''}
                </Descriptions.Item>
              </Descriptions>
            </>
          )}
          {(datosSiniestro.poliza.id_producto === 4 ||
            datosSiniestro.poliza.id_producto === 5 ||
            datosSiniestro.poliza.id_producto === 6) && (
            <>
              <Descriptions title="" {...descriptionProps}>
                <Descriptions.Item label="Dirección">
                  {`${datosSiniestro?.poliza?.solicitud.inmueble.domicilio} - ${datosSiniestro?.poliza?.solicitud.inmueble.distrito.descripcion} - ${datosSiniestro?.poliza?.solicitud.inmueble.departamento.descripcion}` ||
                    ''}
                </Descriptions.Item>
              </Descriptions>
            </>
          )}
        </>
      )}
      {(datosSiniestro.poliza.id_producto === 2 ||
        datosSiniestro.poliza.id_producto === 3) && (
        <>
          <Descriptions title="" {...descriptionProps}>
            <Descriptions.Item label="Nombre y Apellido">
              {datosSiniestro.poliza.persona.nombres}
            </Descriptions.Item>
            <Descriptions.Item label="CI Nro">
              {datosSiniestro.poliza.persona.cedula}
            </Descriptions.Item>
            <Descriptions.Item label="Fecha de Nacimiento ">
              {datosSiniestro.poliza.persona.fecha_nacimiento
                ? moment(datosSiniestro.poliza.persona.fecha_nacimiento).format(
                    'DD-MM-YYYY'
                  )
                : 'Sin fecha'}
            </Descriptions.Item>
          </Descriptions>
        </>
      )}
      <br />
      <Title level={4}>Instrucciones:</Title>
      <Paragraph>
        <p>
          Los <strong>Documentos del Siniestro</strong> pueden ser subidos
          desde:
        </p>
        <ul>
          <li>
            Dispositivo Móvil (<strong>Celular</strong>){' '}
          </li>
          <li>
            Dispositivo de Escritorio (<strong>PC, Notebook</strong>)
          </li>
        </ul>
      </Paragraph>
      <Title level={5} style={{ textDecoration: 'underline' }}>
        Tener en cuenta:
      </Title>
      <Paragraph>
        <ul>
          <li>Aceptar y mantener activada la ubicación</li>
          <li>Tomar las fotografías nítidas y con buena iluminación</li>
          {(datosSiniestro.poliza.id_producto === 1 ||
            datosSiniestro.poliza.id_producto === 7) && (
            <li>Captar la totalidad del vehículo</li>
          )}
          <li>Subir documentos legibles</li>
        </ul>
      </Paragraph>
    </div>
  );
};

export default LandingPage;
